import { useQuery } from '@tanstack/react-query';
import { BaseApi } from '../api/apiBase';

// Create a custom API class to expose the getSimpleJson method
class FormSubmissionsApi extends BaseApi {
  async checkSubmissions(formSlug: string): Promise<ExistingSubmissionsResponse> {
    return this.getSimpleJson<ExistingSubmissionsResponse>(`/forms/${formSlug}/check_submissions`);
  }
}

const api = new FormSubmissionsApi();

interface ExistingSubmissionsResponse {
  hasSubmissions: boolean;
  submissionCount: number;
  lastSubmission: {
    id: string;
    submittedAt: string;
    workflowState: string;
    confirmationNumber: string;
  } | null;
}

export const useFormSubmissions = (formSlug: string, enabled: boolean = true) => {
  return useQuery<ExistingSubmissionsResponse>({
    queryKey: ['formSubmissions', formSlug],
    queryFn: () => api.checkSubmissions(formSlug),
    enabled: enabled && !!formSlug,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};